export enum NativeMessagingVersion {
  One = 1, // Original implementation
  Latest = One,
}
